import { render, staticRenderFns } from "./PollList.vue?vue&type=template&id=2ad231e1&"
import script from "./PollList.vue?vue&type=script&lang=ts&"
export * from "./PollList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports